import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LoggingService } from 'core/logging/logging.service';
import { MatModule } from 'core/material/mat.module';
import { CustomErrorHandler } from './error-handler';
import { ErrorComponent } from './error.component';
import { ErrorService } from './error.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatModule,
  ],
  declarations: [
    ErrorComponent,
  ],
  exports: [
    ErrorComponent,
  ],
  providers: [
    ErrorService,
    LoggingService,
    {
        provide: ErrorHandler,
        useClass: CustomErrorHandler
    },
  ]
})
export class ErrorModule { }



// WEBPACK FOOTER //
// ./src/app/core/error/error.module.ts